"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var gutterWidth = _a.gutterWidth, align = _a.align, justify = _a.justify, direction = _a.direction, wrap = _a.wrap;
    // Vertical alignment
    var alignItems = align;
    if (align === 'start')
        alignItems = 'flex-start';
    if (align === 'end')
        alignItems = 'flex-end';
    // Horizontal alignment
    var justifyContent = justify;
    if (justify === 'start')
        justifyContent = 'flex-start';
    if (justify === 'end')
        justifyContent = 'flex-end';
    if (justify === 'between')
        justifyContent = 'space-between';
    if (justify === 'around')
        justifyContent = 'space-around';
    if (justify === 'center')
        justifyContent = 'center';
    if (justify === 'initial')
        justifyContent = 'initial';
    if (justify === 'inherit')
        justifyContent = 'inherit';
    var flexDirection = ['column', 'row', 'column-reverse', 'row-reverse'].includes(direction)
        ? direction
        : undefined;
    var flexWrap = wrap;
    if (wrap === 'nowrap')
        flexWrap = 'nowrap';
    if (wrap === 'wrap')
        flexWrap = 'wrap';
    if (wrap === 'reverse')
        flexWrap = 'wrap-reverse';
    var styles = {
        marginLeft: -gutterWidth / 2,
        marginRight: -gutterWidth / 2,
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        alignItems: alignItems,
        justifyContent: justifyContent,
        flexDirection: flexDirection,
        flexWrap: flexWrap,
    };
    return __assign({}, styles);
});
//# sourceMappingURL=style.js.map